export interface PwCheck { label: string; pass: boolean }

export function getPwChecks(pw: string): PwCheck[] {
  return [
    { label: 'At least 10 characters',  pass: pw.length >= 10 },
    { label: 'Uppercase letter (A–Z)',   pass: /[A-Z]/.test(pw) },
    { label: 'Lowercase letter (a–z)',   pass: /[a-z]/.test(pw) },
    { label: 'Number (0–9)',             pass: /[0-9]/.test(pw) },
    { label: 'Special character (!@#…)', pass: /[^A-Za-z0-9]/.test(pw) },
  ]
}

export function pwStrength(checks: PwCheck[]): number {
  return checks.filter(c => c.pass).length
}

export function pwAllPass(checks: PwCheck[]): boolean {
  return checks.every(c => c.pass)
}

export function pwStrengthLabel(score: number): { label: string; color: string } {
  if (score <= 1) return { label: 'Weak',   color: '#E0663B' }
  if (score <= 3) return { label: 'Fair',   color: '#D4972B' }
  if (score === 4) return { label: 'Good',  color: '#0F7C6C' }
  return               { label: 'Strong', color: '#0F7C6C' }
}
